module.exports = __webpack_public_path__ + "img/360logo.b7840fc0.png";